module.exports = __webpack_public_path__ + "static/media/no_pant_cuffs.1668e19f.svg";